// ThemeToggle.jsx
import React from 'react';
import { useTheme } from '../../context/ThemeContextDefinition';
import { useLang } from '../../hooks/useLang';

const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();
    const { t } = useLang();

    return (
        <button
            type="button"
            onClick={toggleTheme}
            className={`btn-floating-control ${theme !== 'light' ? 'active-state' : ''}`}
            aria-label={theme === 'light' ? t('controls.theme.switch_dark') : t('controls.theme.switch_light')}
            title={theme === 'light' ? t('controls.theme.switch_dark') : t('controls.theme.switch_light')}
        >
            {theme === 'light' ? '🌙' : '☀️'}
        </button>
    );
};

export default ThemeToggle;

